module.exports = __webpack_public_path__ + "static/media/icon-plus-btn.5ad43bbc.svg";